import { InsuranceHelper } from '../../utils/InsuranceHelper';

export const PRODUCTS = {
  CAR: 'car',
  HOME: 'home',
  VILLA: 'villa-home',
  MC: 'mc',
  ACCIDENT: 'accident',
  MOPED: 'moped',
  PPI: 'ppi'
};

export const PRODUCT_NAME_TO_TRACK = {
  CAR: 'car',
  HOME: 'home',
  VILLA: 'villahome',
  MC: 'mc',
  ACCIDENT: 'accident',
  MOPED: 'moped',
  PPI: 'bokvar' // PPI is tracked as 'bokvar' in the piwikpro
};

export const CHANNELS = {
  GJENSIDIGE: 'gjensidige',
  HGF: 'hgf',
  RIKSHEM: 'rikshem',
  WAHLIN: 'wahlin-fastigheter',
  KLARABO: 'klarabo',
  HGF_PPI: 'hgfppi',
  NIEMI: 'niemi'
};

const APP_CONSTANTS = {
  channel: 'gjensidige',
  application: 'GFSEWEBSHOP',
  productList: [PRODUCTS.CAR, PRODUCTS.HOME, PRODUCTS.VILLA, PRODUCTS.MC, PRODUCTS.ACCIDENT, PRODUCTS.MOPED, PRODUCTS.PPI],
};

export const HOME_COMMON_PARTNERS_CHANNELS = [CHANNELS.RIKSHEM, CHANNELS.WAHLIN, CHANNELS.KLARABO];

export const ADD_ON_PACKAGE_DISABLED_PARTNERS = [CHANNELS.HGF, ...HOME_COMMON_PARTNERS_CHANNELS];

export enum API_OPERATIONS {
  GET_APP_TEXTS = 'GetAppTexts',
  GET_PRODUCT_CONFIG = 'GetProductConfig',
  GET_QUESTION_CONFIG = 'GetQuestionConfig',
  GET_TEMPLATE_DATA = 'GetTemplateData',
  CREATE_INSURANACE_OFFER = 'CreateInsuranceOffer',
  UPDATE_INSURANACE_OFFER = 'UpdateInsuranceOffer',
  GET_TEXTS = 'GetTextsAndGenericIllustrations',
  SAVE_OFFER = 'SaveInsuranceOfferSelection',
  SAVE_AND_SEND_OFFER = 'SaveAndSendInsuranceOverEmail',
  SAVE_ADDITIONAL_PACKAGES = 'SaveAdditionalPackageSelection',
  GET_ALL_OFFERS = 'getAllInsuranceOffers',
  GET_OFFER = 'getInsuranceOffer',
  RESUME_OFFER = 'resumeInsuranceOffer',
  GET_PRODUCT_DOCUMENTS = 'getProductDocuments',
  CHECK_CUSTOMER_ELIGIBILITY = 'checkCustomerEligibility',
  GET_OFFER_SUMMARY = 'GetOfferSummary',
  GET_SAVED_OFFER_SUMMARY = 'GetSavedOfferSummary'
}

export const SESSION_KEYS = {
  APP_TEXT: 'app-texts',
  PRODUCT_CONFIG: 'product-config',
  QUESTIONS_CONFIG: 'question-config',
  CUSTOMER_INFO: 'customerInfo',
  GENERIC_ILLUSTRATIONS: 'genericIllustrations',
  SAVED_POLICY: 'savedPolicyNumber',
  FOLLOW_UP_OFFER: 'followUpOffer',
};

export const HEADER_CONSTANTS = {
  LOGO_TITLE: 'Fortsätt köp',
  CUSTOMER_CARE_NUMBER: '010-483 95 12',
  OPEN_HOURS: 'Öppet vardagar 8.30-17',
  IMAGE_ALT: 'Gjensidiges logotyp, länk till startsidan',
  HGF_CUSTOMER_CARE_NUMBER: '0771-59 59 51',
  RIKSHEM_CUSTOMER_CARE_NUMBER: '010-483 90 91',
  WAHLIN_CUSTOMER_CARE_NUMBER: '010-483 90 56',
  KLARABO_CUSTOMER_CARE_NUMBER: '010-483 90 56'
};
export const PRODUCT_CHANNELS = {
  VILLA_GJENSIDIGE: 'villa-home-gjensidige',
  HOME_GJENSIDIGE: 'home-gjensidige',
  HOME_HGF: 'home-hgf',
  HOME_COMMON_PARTNERS: 'home-common-partners'
}
export const AREA_LIMITS = {
  [PRODUCT_CHANNELS.VILLA_GJENSIDIGE]: {
    MAX: 300,
    MIN: 50
  },
  [PRODUCT_CHANNELS.HOME_GJENSIDIGE]: {
    MAX: 200,
    MIN: 20
  },
  [PRODUCT_CHANNELS.HOME_HGF]: {
    MAX: 200,
    MIN: 20
  },
  [PRODUCT_CHANNELS.HOME_COMMON_PARTNERS]: {
    MAX: 200,
    MIN: 1
  }
};

export const LIVING_AREA_MAX = {
  MAIN_BUILDING: 7,
  EXTRA_BUILDING: 90
};

export const MC_INVALID_PARKING = {
  STREET_PARKING: 'street-parking'
}

export const MIN_CONSTRUCTION_YEAR_VILLA = 1910;
export const MAX_NUMBER_OF_ADDITIONAL_BUILDING_VILLA = 4;

export const MAX_NUMBER_OF_ADDITIONAL_QUESTIONS = {
  [PRODUCTS.VILLA]: MAX_NUMBER_OF_ADDITIONAL_BUILDING_VILLA
};

export const MAX_AREA_ADDITIONAL_BUILDINGS = 180;

export const COMMON_ERROR_IMAGE =
  'https://cdn.gjensidige.no/claims-sweden/sweden-core/images/ExclamationErrorModal_NCI_simple.svg';

export default APP_CONSTANTS;
